import { SpaceDragPreviewLabel as SpaceDragPreviewLabelType } from 'utils/space-label-drag-preview-types';

type SectionColor = { bg: string; border: string; text: string };

type SpaceDragPreviewLabelProps = {
  preview: SpaceDragPreviewLabelType;
  zoom: number;
  hasSectionColor: boolean;
  sectionColor?: SectionColor;
};

export function SpaceDragPreviewLabel({
  preview,
  zoom,
  hasSectionColor,
  sectionColor
}: SpaceDragPreviewLabelProps) {
  return (
    <div
      className='pointer-events-none absolute flex select-none items-center justify-center text-center text-sm font-medium'
      style={{
        left: preview.anchor.x * zoom,
        top: preview.anchor.y * zoom,
        transform: 'translate(-50%, -50%)',
        maxWidth: preview.screenMaxWidth,
        ...(hasSectionColor && sectionColor ? { color: sectionColor.text } : {})
      }}
    >
      <div className='max-w-full break-normal leading-tight text-black'>
        {preview.displayLabel}
      </div>
    </div>
  );
}

type SectionDragPreviewLabelContentProps = {
  displayLabel: string;
};

export function SectionDragPreviewLabelContent({
  displayLabel
}: SectionDragPreviewLabelContentProps) {
  return <div className='leading-tight text-black'>{displayLabel}</div>;
}
